import React, { useState } from "react";
import { Modal, TextInput, Button, Group } from "@mantine/core";
import classes from "./AddKpi.module.css";

interface RowData {
  objectiveId: string;
  title: string;
  description: string;
  action: string;
}

interface AddKPIModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAddKPI: (newKPIData: RowData) => void;
}

const AddKPIModal: React.FC<AddKPIModalProps> = ({
  isOpen,
  onClose,
  onAddKPI,
}) => {
  const [newKPI, setNewKPI] = useState<RowData>({
    objectiveId: "",
    title: "",
    description: "",
    action: "",
  });

  const handleAddKPI = () => {
    // Check if any required fields are empty
    if (!newKPI.title || !newKPI.description) {
      alert("Please fill in all the required fields");
      return;
    }

    onAddKPI(newKPI);

    // Clear inputs and reset state
    setNewKPI({
      objectiveId: "",
      title: "",
      description: "",
      action: "",
    });

    onClose();
  };

  const handleClose = () => {
    // Clear inputs and reset state
    setNewKPI({
      objectiveId: "",
      title: "",
      description: "",
      action: "",
    });

    // Call the onClose function
    onClose();
  };

  return (
    <Modal
      title={
        <div style={{ textAlign: "center", fontWeight: "bold" }}>
          New KPI Objective
        </div>
      }
      opened={isOpen}
      onClose={handleClose}
      fs={"bold"}
    >
      <TextInput
        label="Title"
        placeholder="Input a title"
        mb="sm"
        maxLength={255}
        value={newKPI.title}
        onChange={(event) =>
          setNewKPI({ ...newKPI, title: event.currentTarget.value })
        }
      />

      <TextInput
        label="Description"
        placeholder="Input a description"
        mb="sm"
        maxLength={255}
        value={newKPI.description}
        onChange={(event) =>
          setNewKPI({ ...newKPI, description: event.currentTarget.value })
        }
      />

      <Group className={classes.buttonBottom}>
        <Button onClick={() => onClose()} className={classes.buttonBack}>
          Back
        </Button>
        <Button onClick={handleAddKPI} className={classes.buttonSubmit}>
          Submit
        </Button>
      </Group>
    </Modal>
  );
};

export default AddKPIModal;
